import moment from "moment";
import { LoadState } from "../../constants/enums";
import { STANDARD_APP_DATE_FORMAT } from "../../constants/constants";

export interface ILeadsfromWebsiteState {
  list: {
    list: ILeadfromWebsite[];
    totalRecords: number;
    loading: LoadState;
    // error: string | null;
  };
  leadfromWebsite: {
    data: ILeadfromWebsite;
    loading: LoadState;
    error: string | null;
  };
  // generalHistory: {
  //   list: IGeneralHistory[];
  //   loading: LoadState;
  // };
  // recordCounts: {
  //   list: ILeadStatusCount[];

  //   loading: LoadState;
  // };
}

export interface ILeadfromWebsite {
enquiry_request_uuid: string;
 name: string;
  state: string ;
  city: string ;
  email: string;
  mobile_no: string;
  company_name: string;
  fleet_size: string;
  vehicle_type: string;
  disposition: string;
  other_disposition: string;
  status: string;
  company_outlet_uuid: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
}

export const initialHelpingLead: ILeadfromWebsite = {
 enquiry_request_uuid: "",
 name: "",
  state: "",
  city: "",
  email: "",
  mobile_no: "",
  company_name: "",
  fleet_size: "",
  vehicle_type: "",
  disposition: "",
  other_disposition: "",
  status: "-1",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialLeadfromWebsiteState: ILeadsfromWebsiteState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  leadfromWebsite: {
    data: initialHelpingLead,
    loading: LoadState.NotLoaded,
    error: null,
  },
  // generalHistory: {
  //   list: [],
  //   loading: LoadState.NotLoaded,
  // },
  // recordCounts: {
  //   list: [],

  //   loading: LoadState.NotLoaded,
  // },
};

export interface ILeadStatusCount {
  [key: string]: number;
}

// export interface IGeneralHistory {
//   insert_ts: string;
//   [key: string]: any;
// }
